import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Card, Loader, Stack, Text } from '@mantine/core';
import { authApi } from '../../lib/auth-api';

function Logout() {
  const navigate = useNavigate();
  useEffect(() => {
    authApi.logout().finally(() => navigate({ to: '/auth/login' }));
  }, [navigate]);
  return (
    <Card>
      <Stack align="center" gap="sm">
        <Loader />
        <Text size="sm" c="dimmed">
          Signing you out…
        </Text>
      </Stack>
    </Card>
  );
}

export const Route = createFileRoute('/auth/logout')({ component: Logout });
